//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'PIROCAP',
  data() {
    return {
      form:{
        age:'0',
        comorbidities:'0',
        bacteremia:'0',
        shock:'0',
        arf:'0',
        hypoxemia:'0',
        opacities:'0',
        ards:'0'
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // (age ? 1 : 0) + (comorbidities ? 1 : 0) + (bacteremia ? 1 : 0) + (opacities ? 1 : 0) +	(shock ? 1 : 0) + 	(hypoxemia ? 1 : 0) + (ards ? 1 : 0) + (arf ? 1 : 0)
        let result = form.age + form.comorbidities + form.bacteremia + form.opacities + form.shock + form.hypoxemia + form.ards + form.arf
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/PIROCAP.vue